import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const GRAPH_IMG =
  'https://customer-assets.emergentagent.com/job_dc9e3538-f079-41ff-9232-076517c20916/artifacts/ohrw8n76_image.png';

const CrossProjectSection = () => {
  return (
    <section id="use-cases" className="bg-[#FBF8F7] pt-24 md:pt-32 pb-2 md:pb-4">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 grid lg:grid-cols-[0.82fr_1.18fr] gap-12 lg:gap-16 items-center">
        {/* Left: copy + CTA */}
        <div className="animate-[fadeUp_0.7s_ease-out_both]">
          <p className="text-[#7A5A2E] text-[12px] tracking-[0.24em] uppercase mb-6">The real unlock</p>
          <h2
            className="text-[#1F1812] leading-[1.08] tracking-[-0.02em]"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 500,
              fontSize: 'clamp(2rem, 3.8vw, 3rem)',
            }}
          >
            Design tools manage tasks. Archen™ learns projects.
          </h2>
          <p className="mt-7 text-[#5C4F42] text-[16px] leading-[1.75] max-w-[460px]">
            Every other system is empty until someone fills it. That's why they fail. Archen™ fills
            itself, and what it builds isn't a task list. It's a record that carries forward: the vendor
            who runs late, the client who disputes invoices, the decision that took three rounds last time.
          </p>
          <Link
            to="/foundingdesigner"
            data-testid="cross-project-cta"
            className="mt-10 inline-flex items-center gap-2 bg-[#2D2520] text-white text-[14px] font-medium px-6 py-3.5 rounded-md transition-all duration-300 hover:bg-[#1F1812] hover:shadow-lg"
          >
            Explore cross-project intelligence
            <ArrowRight size={15} />
          </Link>
        </div>

        {/* Right: knowledge graph (no container, blends into background) */}
        <img
          src={GRAPH_IMG}
          alt="Archen™ links vendors, materials, decisions, clients, lessons and specifications across every project"
          data-testid="cross-project-graph"
          className="w-full animate-[fadeIn_0.9s_ease-out_both]"
        />
      </div>

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
      `}</style>
    </section>
  );
};

export default CrossProjectSection;
